import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ContactPaymentDetailsPage.InfoPanel.EmptyPaymentDetails', {
    title: 'Payment details',
    noPaymentDetails: 'No payment details',
    description: 'Please add payment details to send payments to this contact.',
    addDetails: 'Add payment details',
});
